module.exports = __webpack_public_path__ + "img/award-1-min.9f602486.png";